import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/UserPayment`;


const paymentService = {
  getPortalList: (params) => {
    const url = `${baseServiceUrl}/GetPortalList`;
    return ServiceApi.get(url, { params });
  },
  getEnumType: () => {
    const url = `${baseServiceUrl}/getPaymentType`;
    return ServiceApi.get(url);
  },
  get: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.get(url);
  },
  createPaymentPortalType: (input) => {
    const url = `${baseServiceUrl}/create-portalType`;
    return ServiceApi.post(url, input);
  },
  update: (id, data) => {
    const url = `${baseServiceUrl}/update-amusementService`;
    return ServiceApi.put(url, data);
  },
  delete: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.delete(url);
  },
  getAllServices: () => {
    const url = `${baseServiceUrl}/getAllServices`;
    return ServiceApi.get(url);
  },
  updatePaymentPortalType: (data) => {
    const url = `${baseServiceUrl}/update-userPaymentPortalType`;
    return ServiceApi.put(url, data);
  }
};

export default paymentService;


